import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import classes from "./Disabled.module.scss";

export function Disabled({ children, className }) {
  return <div className={cx(classes.root, className)}>{children}</div>;
}

Disabled.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  className: PropTypes.string,
};

Disabled.defaultProps = {
  className: undefined,
};
